import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceLine } from "recharts";
import { formatCurrency, formatCompactCurrency } from "@/utils/shared/currencyUtils";

interface BusinessProfitChartProps {
  data: Array<{ month: string; amount: number }>;
}

const BusinessProfitChart = ({ data }: BusinessProfitChartProps) => {
  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      const value = payload[0].value;
      const isPositive = value >= 0;
      
      return (
        <div style={{
          backgroundColor: "hsl(var(--card))",
          border: "1px solid hsl(var(--border))",
          borderRadius: "8px",
          padding: "12px",
          boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)"
        }}>
          <p className="font-medium text-sm">{payload[0].payload.month}</p>
          <p className={`font-semibold ${isPositive ? 'text-success' : 'text-destructive'}`}>
            {formatCurrency(value)}
          </p>
        </div>
      );
    }
    return null;
  };

  const CustomBar = (props: any) => {
    const { fill, x, y, width, height, payload } = props;
    const isPositive = payload.amount >= 0;
    const barFill = isPositive ? "hsl(var(--success))" : "hsl(var(--destructive))";
    
    return (
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        fill={barFill}
        rx={4}
      />
    );
  };

  return (
    <ResponsiveContainer width="100%" height={320}>
      <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid 
          strokeDasharray="3 3" 
          stroke="hsl(var(--border))" 
          opacity={0.3}
        />
        <XAxis 
          dataKey="month" 
          angle={-45}
          textAnchor="end"
          height={70}
          interval={0}
          axisLine={{ stroke: "hsl(var(--border))" }}
          tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 12 }}
        />
        <YAxis 
          width={45}
          tickFormatter={(value) => formatCompactCurrency(value)}
          axisLine={{ stroke: "hsl(var(--border))" }}
          tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 12 }}
        />
        <Tooltip 
          content={<CustomTooltip />}
          cursor={{ fill: "rgba(0, 0, 0, 0.05)" }}
        />
        <ReferenceLine y={0} stroke="hsl(var(--border))" strokeWidth={2} />
        <Bar 
          dataKey="amount" 
          shape={<CustomBar />}
          barSize={30}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default BusinessProfitChart;
